import {useFormik} from 'formik'
import * as Yup from 'yup'
import {Button, Card, Col, Form, ListGroup, Row, Spinner} from 'react-bootstrap'
import {IResEditUser, NodeOne} from '../../../graphql/types/usersTypes'
import {useEffect} from 'react'
import {useMutation} from '@apollo/client'
import {EDIT_USER} from '../../../graphql/mutations/userMutations'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'

const validationSchema = Yup.object({
  firstName: Yup.string().required('Nombres es requerido'),
  lastName: Yup.string().required('Apellidos es requerido'),
  email: Yup.string()
    .email('Correo electrónico inválido')
    .required('Correo electrónico es requerido'),
})

interface IResumen {
  user: NodeOne
  refetch: () => void
}

export const ResumenOneUser: React.FC<IResumen> = ({user, refetch}) => {
  const [gqlEdit, {data, loading, error}] = useMutation<IResEditUser>(EDIT_USER)

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
    },
    validationSchema,
    onSubmit: (values) => {
      if (
        values.email === user.email &&
        values.firstName === user.firstName &&
        values.lastName === user.lastName
      ) {
        return
      }
      gqlEdit({
        variables: {
          input: {
            ...values,
            id: parseId(user.id),
          },
        },
      })
    },
  })

  useEffect(() => {
    if (!user) return
    formik.setValues({
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    if (error) toast.error(`Error: ${error}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.userUpdate.success) {
      toast.success('Usuario editado correctamente')
      refetch()
    } else if (data.userUpdate.errors) {
      toast.error(`Error: ${data.userUpdate.errors.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <div className='animation animation-fade-in'>
      <Card className=''>
        <Card.Body>
          <Form onSubmit={formik.handleSubmit} id='formId'>
            <Row>
              <Col sm={12} md={6}>
                <Form.Group controlId='firstName'>
                  <Form.Label>Nombres</Form.Label>
                  <Form.Control
                    type='text'
                    name='firstName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.firstName}
                    isInvalid={Boolean(formik.touched.firstName && formik.errors.firstName)}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.firstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm={12} md={6}>
                <Form.Group className='' controlId='lastName'>
                  <Form.Label>Apellidos</Form.Label>
                  <Form.Control
                    type='text'
                    name='lastName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.lastName}
                    isInvalid={Boolean(formik.touched.lastName && formik.errors.lastName)}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.lastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className='mt-3' controlId='email'>
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control
                type='email'
                name='email'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                isInvalid={Boolean(formik.touched.email && formik.errors.email)}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Card.Body>
        <Card.Footer>
          <div className='d-flex align-items-center justify-content-end w-100'>
            <Button type='submit' form='formId' disabled={loading}>
              {loading && <Spinner animation='border' size='sm' className='me-2' />}
              Guardar
            </Button>
          </div>
        </Card.Footer>
      </Card>

      <Card className='mt-5'>
        <Card.Header>
          <Card.Title>Grupos</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className='w-100 w-md-50'>
            <ListGroup as='ol' numbered>
              {user.groups.edges.map(({node}) => (
                <ListGroup.Item
                  key={node.id}
                  as='li'
                  className='d-flex justify-content-between align-items-start'
                >
                  <div className='ms-2 me-auto'>
                    <div className='fw-bold'>{node.name}</div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}
